import React from 'react';

function Signature(data) {

    return(
        <>
            {data.remark}
            <table width="560" style={{width: "560px", maxWidth: "100%"}}>
                <tbody>
                <tr>
                    <td width={data.logoWidth} style={{
                        paddingRight: "5px",
                        width: data.logoWidth + "px"
                    }}>
                        <table width="100%" cellPadding="0" style={{
                            borderSpacing: 0,
                            borderCollapse: 'collapse'
                        }}>
                            <tbody>
                            <tr>
                                <td>
                                    <img src={data.logo} alt="" width={data.logoWidth}/>
                                </td>
                            </tr>
                            {
                                data.logoText !== '' &&
                                <tr>
                                    <td style={{
                                        fontSize: "9px",
                                        textAlign: "right",
                                        fontWeight: "bold",
                                        fontFamily: 'arial',
                                        lineHeight: '10px',
                                        paddingTop: '3px'
                                    }}
                                    >
                                        A member of <span style={{color: '#223d92', fontSize: '11px'}}>N<span
                                        style={{color: '#188d44'}}>E</span>TIS</span> Group
                                    </td>
                                </tr>
                            }
                            </tbody>
                        </table>
                    </td>
                    <td width={560 - data.logoWidth} style={{
                        fontFamily: "arial",
                        color: "#2b1e8a",
                        fontSize: "14px",
                        padding: "0 0 0 10px",
                        fontWeight: "bold",
                        lineHeight: "19px"
                    }} valign="bottom">
                        {data.firstName} {data.lastName}<br/>
                        {data.position}<br/>
                        <font style={{color: "#0f9c10"}}>{data.country}</font>
                    </td>
                </tr>
                <tr>
                    <td colSpan="2" style={{
                        padding: "5px 0 0",
                        fontSize: "11px",
                        color: "#0372c3",
                        fontFamily: "arial",
                        lineHeight: "15px"
                    }}>
                        {
                            (data.mobile && data.whatsapp && data.mobile === data.whatsapp) &&
                            <>Mob / Whatsapp: {data.mobile}</>
                        }
                        {
                            (data.mobile !== data.whatsapp) &&
                            <>
                                {data.mobile && <>Mobile: {data.mobile}</>}
                                {(data.mobile && data.whatsapp) && <> | </>}
                                {data.whatsapp && <>Whatsapp: {data.whatsapp}</>}
                            </>
                        }

                        {((data.mobile !== '' || data.whatsapp !== '') && (data.email !== '' || data.skypeId !== '')) && <br/>}

                        {data.email && <>E-mail: <u>{data.email}</u></>} {(data.email && data.skypeId) && <>|</>} {data.skypeId && <>Skype
                        ID: {data.skypeId}</>} <br/>
                    </td>
                </tr>
                <tr>
                    <td style={{padding: "0", fontSize: "11px", color: "#0372c3", fontFamily: "arial", lineHeight: "17px"}}
                        colSpan="2">
                        <a href="http://netisgroup.net/"
                           style={{fontSize: "11px", color: "#0372c3", textDecoration: "underline"}}>http://netisgroup.net/</a>
                    </td>
                </tr>

                <tr>
                    <td style={{padding: "0"}} colSpan="2">
                        <a href="https://www.facebook.com/NETISGROUP/"><img src="https://i.imgur.com/5MVyAfF.png" alt="Facebook"/></a>&nbsp;
                        <a href="https://www.linkedin.com/company/netis-group/"><img src="https://i.imgur.com/69hLtxC.png" alt="Linkedin"/></a>&nbsp;
                        <a href="https://www.youtube.com/channel/UCDJkXCB3FpMtFKmr-WwQ6IA"><img src="https://i.imgur.com/PFzIUB8.png" alt="Youtube"/></a>
                    </td>
                </tr>
                <tr>
                    <td colSpan="2" style={{padding: "0", fontSize: "11px"}}><img src="https://i.imgur.com/ZywL4qw.jpg" width="13" style={{width: "13px"}}/> <font
                        style={{color: "#0f9c10", fontWeight: "bold"}}>please consider the environment before printing this
                        email</font></td>
                </tr>
                <tr>
                    <td colSpan="2" style={{fontSize: "10px", color: "#0372c3", paddingTop: "0"}}>This message is private and
                        confidential. If you receive this message by error, please notify us and remove it from your system.
                    </td>
                </tr>
                <tr>
                    <td colSpan="2">
                        <img src={data.image} alt="" width={data.imageWidth}/>
                    </td>
                </tr>
                </tbody>
            </table>
        </>
    )
}

export default Signature;
